function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from 'react';
import { FileDragDrop } from '../../..';
import InputWrapper from '../InputWrapper/InputWrapper';
import useValidationProps from '../../hooks/useValidationProps';
import { Controller } from 'react-hook-form';
import { COLOURS } from '../../../../pp2/theme';
import { FaCloudUploadAlt } from 'react-icons/fa';
/**
 * <ValidatedFileUpload /> drop in replacement for TQ <FileDragDrop /> component.
 *
 */
var ValidatedFileUpload = props => {
  var inputProps = useValidationProps(props);
  return /*#__PURE__*/React.createElement(InputWrapper, props, /*#__PURE__*/React.createElement(Controller, {
    name: props.id,
    render: _ref => {
      var {
        field
      } = _ref;
      return /*#__PURE__*/React.createElement(FileDragDrop, _extends({}, inputProps, field, {
        sx: {
          border: ["2px dashed ".concat(COLOURS.blue[600]), "1px solid ".concat(COLOURS.gray[300])],
          bg: [COLOURS.blue[150], COLOURS.gray[100]]
        },
        onChange: value => {
          var _props$onChange;
          field === null || field === void 0 ? void 0 : field.onChange(value);
          props === null || props === void 0 ? void 0 : (_props$onChange = props.onChange) === null || _props$onChange === void 0 ? void 0 : _props$onChange.call(props, value);
        },
        icon: /*#__PURE__*/React.createElement(FaCloudUploadAlt, {
          style: {
            fontSize: '2.5rem'
          }
        })
      }), props.children);
    }
  }));
};
export default ValidatedFileUpload;